var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"col-4 btn-select m-3 btn-w-shipTime",class:{
    selecting: _vm.isSelecting,
    disabled: _vm.isDisabled,
  },on:{"click":function($event){return _vm.btnClick(_vm.time)}}},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.time)+" "),(_vm.isSpecial)?_c('span',{staticClass:"mx-2"},[_vm._v("加開")]):_vm._e(),(_vm.isFull)?_c('span',{staticClass:"mx-2"},[_vm._v("額滿")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }